import { i18n } from '@/language/index';
import store from '@/store';
import { identityNumberLabel } from '@/utils/tools/utils';

// 卡号是否有符合cardRules规则
export function getCard(value, matchDBCardInfo = true) {
  const cardNumber = value.replace(/\s*/g, '');
  let card = null;
  let cardType = null;

  for (let i = 0; i < cardRules.length; i++) {
    if (cardRules[i].pattern.test(cardNumber)) {
      const len = cardRules[i].length;
      if (len.includes(cardNumber.length)) {
        card = cardRules[i];
        // 符合正则的卡号在商户支持的卡种内
        if (matchDBCardInfo) {
          const supportCards = store.getters.app.supportCards;
          for (let j = 0; j < supportCards.length; j++) {
            if (card.cardType === supportCards[j].cardType) {
              cardType = supportCards[j];
              break;
            }
          }
        }
      }
      break;
    }
  }

  return matchDBCardInfo ? cardType : card;
}

export const cardRules = [
  {
    type: 'Amex',
    pattern: /^3(379(1[23]|41)|[47])/,
    length: [15],
    cvcLength: [3, 4],
    cardType: 'AMEX', // 后端未匹配
  },
  {
    type: 'JCB',
    pattern: /^(2131|3(0(8[89]|9[0-46-9])|1(0[012]|1[2-9]|20|5[89])|3(3[789]|4)|5(2[89]|3([0-579]|6(0[1-9]|[1-9])|8(04|1[1-9]|[2-9]))|[4568]|7([02-9]|1([02-9]|1[02-9])))))/,
    length: [16, 17, 18, 19],
    cvcLength: [3],
    logo: require('@/assets/images/cards/JCB.png'),
    cardType: 'JCB',
  },
  {
    type: 'DinersClub International',
    pattern: /^(3(0(0(0(0[1-9]|[1-9])|[1-9])|[1-5]|95)|[69]|8([0-35-8]|4([02-9]|1([046][1-9]|[1235789]))|9([0-8]|9([0-8]|9[02-9]))))|650482)/,
    length: [14],
    cvcLength: [3],
    logo: require('@/assets/images/cards/DinersClub.png'),
    cardType: 'DINERSCLUB',
  },
  {
    type: 'AmericanExpress',
    pattern: /^3(379(1[23]|41)|[47])/,
    length: [15],
    cvcLength: [3, 4],
    logo: require('@/assets/images/cards/AmericanExpress.png'),
    cardType: 'AE',
  },
  {
    type: 'Maestro',
    pattern: /^(2(18441|2(2(88[89]|9(09|1[059]))|923[789])|30(881|9([12]7|63|9[34]))|50000)|5(0(0(0(0[589]|14|2[026]|3[236]|4[0138]|5[135-8]|[69][24]|75|8[17])|1(0[35]|1[256]|22|3[89]|48|6[356]|87|91)|2([08]8|[17]6|25|3[2458]|51|94)|3(10|3[03]|44|65|7[1238]|82)|4(01|1[067]|43|52|79|80)|5(02|[39]9|5[89]|68)|6(0[04]|2[789]|30|49|54|[68][58]|7[78]|9[0158])|7(01|1[19]|[27]6|33|4[05]|5[28]|6[12468]|8[0346]|97)|8(0[12]|21|45|5[47])|9(5[37]|94))|1(0(0[012568]|1[0-35689]|2[02-9]|38|4[0124-79]|5[013-9]|6[0-8]|7[0-5]|8[0-47]|9[1789])|1([02][29]|1[156]|31|4[03]|55|6[069]|7[04])|2(0[15]|12|35|5[48]|6[23]|70|81)|3(0[5679]|[167]9|2[79]|3[37]|4[12])|4(02|[57]7|84)|5([06]0|2[36]|39|95)|6(09|[25][1-59]|3[247]|4[89])|7(49|6[5679]|7[467]|9[359])|8(0[1237]|1[12]|28|3[57]|[46]5|5[1359]|7[6-9]))|2(0(0[01259]|[19]|2[013-69]|3[0-4789]|4[0-35689]|5[1-46-9]|6[0135689]|7[1235]|8[0156])|1(0[0-7]|1[39]|[23][0-6]|4[248]|50|6[056]|7[03]|8[128]|9[0259])|2(0[067]|1[12379]|2[59]|3[07]|4[027]|5[0249]|6[028]|70|8[236]|9[013])|3(0[12]|12|21|39|[58][69]|6[0369]|7[25]|9[1369])|4(0[36]|[13][369]|2[038]|4[489]|53|[69][38]|7[03])|5(0[025]|1[369]|2[358]|3[236]|4[48]|90)|6(2[13]|5[07]|97)|7(0[14]|22|30|6[67]|7[012]|87|94)|8(1[02]|2[2-57]|4[69]|5[01]|8[09])|9(0[01458]|1[125-8]|2[4568]|3[0127]|4[12389]|5[13468]|6[369]|7[013568]|8[014-7]|9[0135-9]))|3(0(0[23]|23|3[46]|44|51)|1(0[012]|2[47]|31|4[014]|6[238]|7[158]|8[34])|2(0[0-356]|2[23]|3[45]|47|64|93)|3(0[39]|37|48|[57][59]|63|8[69]|9[378])|4(0[0689]|1[038]|20|4[1349]|5[26]|8[27]|93)|5(0[039]|1[23]|26|55|63|7[2459]|8[3-69]|9[259])|6(0[013689]|1[0356]|2[169]|3[04]|4[56]|70|8[1489]|9[79])|7(00|[13]4|55|8[59]|93)|8(0[158]|37|4[79]|5[37]|[67]1|8[1456])|9(0[56]|4[68]|60))|4(0(05|19|[23]2|40|[56])|1(0[014]|40|5[2578]|6[18]|7[02]|8[279]|94)|2(0[08]|[14]1|2[01]|55|6[056])|3(0[01]|1[01379]|2[234]|3[1689]|4[27]|58|6[37]|[79]4|8[47])|4(0[15]|1[039]|23|3[023579]|5[468]|6[058]|87|9[23])|5(0[146]|11|26|3[369]|4[069]|5[29]|6[23]|7[46]|9[05])|6(1[138]|2[078]|39|4[259]|5[46]|6[18]|78|8[15]|9[67])|7(0[68]|1[46]|2[01]|38|41|5[1235]|66|7[125]|8[145]|9[35])|8(0[89]|1[57]|20|34|[46]8|5[03]|7[178]|8[249]|9[79])|9(17|24|3[17]|46|[79]3))|5(0(0[79]|1[28]|74)|1(05|2[01]|4[46])|2(0[014]|[129]1|44|5[02]|63|72|85)|3([04]3|5[34])|4(09|2[279]|33|4[18]|52|88|90)|5(0[06]|1[23]|23|35|5[02]|9[09])|6(1[36]|2[456]|4[3789]|5[05]|78)|7([04]6|51|77|8[05]|9[13])|8(0[04]|1[26]|2[3567]|[36]2|5[057]|74|88)|9(00|41|[79]8|8[79]))|6(0(0[0135]|95)|1(0[024568]|1[0568]|2[02368]|47|55|68)|2(0[058]|1[03]|3[0269]|4[0129]|6[1467]|7[05]|8[24-7]|9[1-6])|3(0[4578]|38)|4(54|82)|5(00|1[24]|43|65)|6(06|[15][25]|[28]3|30|6[189])|8([09]4|49)|9(08|11|[36][58]|82|97))|7(0(0[1249]|1[056]|25|4[0169]|62|74|8[29]|9[012])|10[09]|2(11|7[02]|93)|3(02|24|40|57|96)|4(0[01]|5[07]|63|7[39]|9[78])|5(0[25]|35|8[12]|97)|6(0[045]|2[39]|42)|753|8(00|46|5[017]|[68][16])|9(07|51|93))|8(0([02]1|[34]6|52|98)|1(0[023]|1[134]|2[24-79]|4[0459]|5[059]|60|88|9[04])|2(0[27]|2[67]|3[3467]|4[13-68]|50|9[34])|327|4([08]6|18|[25]0|4[69]|73|91)|5(13|35|[58]0)|858|900))|2(4551|5810|7312|9(235|795))|3(6106|9145)|5(0016|45(0[49]|63|87|92)|7999|8562)|6(0(0(0[01]|1[04-7]|[26]5|4[25]|54|76)|1(01|14|27|30|4[69]|[589]2|6[26])|2(01|2[0-46]|3[012]|5[1-9]|6[578]|7[478]|80|9[189])|3(0[3459]|11|2[17]|3[0129]|7[2347]|8[07]|9[036])|4(0[08]|1[012]|23|70)|5(10|24|4[08]|65|76)|6(2[58]|34|[57]7|63)|7([01][69]|2[02-589]|3[13578]|40|51|65|89)|8(01|29|5[156]|8[26])|9(00|8[079]))|1(0(0[03]|1[01]|2[07]|33|4[26]|5[46-9]|66|70)|1(11|24|98)|2(0[0246]|1[02-57]|2[0124579]|[39][013-9]|4[0-578]|5[02-9]|6[0135-9]|7[12789]|8[1-4789])|3(2[0369]|3[2458]|4[2358]|5[256]|67)|4(09|[23]2|[48]8|5[25]|64)|5(16|25|[34]0)|6(02|1[35]|57|60|81)|7(18|57|8[1356])|890|9([26]3|45))|2(0(01|14|49|9[39])|1(39|97)|2(0[28]|25|[68]3)|3(00|24|33|47|5[46]|78)|4(33|69)|5([17]0|48)|6(01|66|87|98)|7(07|26)|8(37|44|70|9[68])|9(6[45]|7[04]))|3(0(0[68]|14|37|51|8[15])|1([05]0|[12][04])|2(1[02]|45|89)|3([05]8|2[17])|4(04|1[04]|22|75)|5(1[38]|35|4[367]|57|60|7[45])|6(4[145]|[57]2|6[56]|81)|7(01|38|47|74)|8(05|[24][23]|[59]7|86)|9(16|7[35]|98))|4(0(05|18|2[23]|7[37]|97)|1(0[0124568]|1[1469]|2[05]|3[0157]|4[178]|55|6[0279]|8[02457]|9[234])|2(1[23]|22|4[68]|54|61|8[07]|95)|3(07|2[234]|4[057]|5[27]|78|8[05]|9[47])|4(00|1[19]|2[156]|32|47|6[04]|76|85)|5([12]9|[36][34]|4[07]|[58]6|7[78]|98)|6(00|16|21|4[56]|5[145]|64|78|8[04]|99)|7(12|[25]7|38|6[56]|8[79]|93)|8(0[79]|2[27]|4[56]|5[38]|72|88|94)|9(0[01]|[12]0|4[23]|75|8[356]|96))|5([01]01|2([02][47]|[17]8|6[24])|3(2[15]|4[05]|54)|4(3[24]|4[45]|5[57]|6[158]|78|87)|5(4[69]|56|6[678]|82)|6(0[06]|16|[29]5|43|5[346-9]|6[35]|7[69]|8[27])|7(13|68|9[23])|8(43|5[489]|6[01]|78|85|96)|9([02][12]|[38]5|4[234]|50))|6(061|1(02|2[05]|31|50|6[0156]|74)|2(1[48]|[26]0|7[89]|8[01])|3(0[89]|47|75|8[368])|4(1[34]|5[0148]|68)|5(40|57|64)|6(0[47]|5[57]|66|77)|7(01|26|34|69|7[489])|8(10|37|[69]8)|9(14|38|40|73|89))|7(0(00|11|29|4[07]|62|97)|1([17]2|83)|2(03|28|65)|3([46]0|59|8[67])|4(3[4689]|49|53|97)|5(64|76|[89]7)|6(2[48]|34|49|5[036])|7(3[0134]|49|88|93)|8([08][09]|[12]1|39|5[02]|98)|9(14|28|35|5[026]|70))|8(0(5[03]|96)|1(28|4[59]|72)|2(17|28)|3(09|[25]7)|4(25|[57]9|62|9[89])|5(3[25]|44|66)|6(35|6[06]|70|8[39])|7(00|12|4[125]|5[56]|85|99)|8(30|56|62|8[27])|9(0[03]|1[24]|25|32|4[18]|5[2468]|6[57]|7[14]|87|99))|9(0([07]0|29|35)|110|2([09]7|32|5[46]|65)|3(1[29]|21|5[26]|65)|4(69|78)|5(10|99)|6(06|1[246]|47|55)|7(10|[24]5)|8(1[58]|2[35]|3[02]|4[57]|5[2456]|7[248]|8[59]|99)|9(16|20|3[48]|9[04])))|7(0(0(0[1-49]|1[126]|2[158]|3[13]|42|6[26]|86)|1([0179]0|2[359]|[38][02]|4[15]|55)|2(12|3[46]|43|55|87)|3(1[13]|22|7[3-6]|88|94)|4(02|[12]3|4[25]|5[38]|60|77|8[16]|98)|5(19|[24]5|86|98)|67[03]|7(0[01]|1[124]|2[03]|46|58)|8(65|74|88)|9([014]7|82))|1(0([14]0|37|81)|1([05]0|[13]4|42|67|7[56])|2(0[01]|1[06]|3[13]|61)|3(06|1[2356]|3[46]|53|92)|4(07|32|4[04]|5[69])|5(0[15]|1[23]|27|42|6[35]|[89]1)|6(15|90)|7([02]2|[56]0)|8(1[03]|37|5[29]|71|84|90)|9(04|3[01]|6[89]|73))|2(0(22|38)|1(36|88|9[06])|2([056]1|26|84)|3([08]9|10|25|[35]2|46)|4(0[269]|10|89|9[67])|5(1[15]|42)|6([04]2|10|2[56])|7([347]4|87)|8(1[579]|[23]8|69)|9(37|4[34]|68))|3(0(0[03]|24|3[79]|67|[89]9)|1(01|49|[69]2|83)|2(17|78|83)|3(30|73|88)|4(29|4[38]|58|60|9[057])|5([0457]0|1[03]|36|93)|6([01]5|77|8[49])|7(0[26]|39|42|7[013]|85)|8(22|[37]7|6[03])|9(05|[45]1))|4(0(01|29|50|85)|1(0[08]|28|31|4[36]|53|65|72)|2([02]6|1[127]|34|5[07]|6[36])|3(24|32|4[37]|5[47])|4([14]1|6[48]|7[02-58]|89|9[17])|564|6(25|72)|7(1[45]|[39]1|40)|8(4[38]|50|8[57]|9[48])|9([023]3|57))|5(0(0[013]|39|80)|1(05|1[2367]|2[89]|3[01]|41|84)|2(4[35]|8[07])|30[028]|4([27]7|3[58]|49|5[036]|88)|5(00|7[678])|6(32|63|7[0258]|90)|7(03|12|30|51|7[01]|97)|8(09|[35]6|4[39])|9(05|12|2[03]|4[04]|57|6[478]|73))|6(0(02|1[89]|7[68]|9[047])|1(24|35|9[68])|2(0[15]|1[17]|20|3[02]|4[38]|58|83)|3(19|6[14]|74|8[25]|96)|4(09|16|3[67]|4[69]|51|62|7[019]|85)|5(07|4[369]|54|65|88)|6([17]6|24|4[05]|67|82)|7([08]9|2[25]|4[23])|8(27|4[37]|75|80|9[04])|9(04|2[15]|45|52|87))|7(0(21|42|69)|1(0[01]|29|[37]6|48|54|97)|2[58]1|349|4(12|38|4[46]|64|96)|5(03|20|88|97)|6(3[28]|68|94)|7(06|[17]0|[35]7|65|83)|8(0[57]|45|54|76|8[14])|920)|8(0(20|43|5[38]|87|96)|1(58|64|8[01])|2(1[24]|[39]4|5[15])|3[69]4|4([259]6|34|71)|5(32|41|73)|6(00|[159]4|33|45|62)|7(24|6[157]|88|91)|8(17|34|53|88|9[01])|9(0[01]|2[048]|3[057]|46|6[49]|8[04]|90))|9(0(02|27|[59]5|60|76)|1(00|23|64)|28[48]|3(07|59|9[05])|4([19]4|48|55)|5(25|43)|6(20|38|41|6[48]|8[89])|7(07|2[0346]|30|4[257]|6[2356]|7[02])|8([01]3|21|67|7[68]|8[36]|9[145])|9(03|2[38]|3[24578]|[47][24]|54|6[19]|8[1-8]|9[034579])))|8(0(0(0[12]|1[69]|2[38]|3[014]|[67]3|87)|1([0169]0|2[02]|4[89]|5[157])|2([16]0|31|4[014]|72|87|95)|3(02|13|34|4[69])|4([15]4|20|4[01]|93)|5(05|12|39|67|83)|6(01|[14]2|2[18]|97)|7(15|46)|8(1[789]|28)|9(04|1[1269]|37|[68]0|72))|1(0(0[35]|1[07]|3[25]|51|60|72|9)|1(00|49|5[17]|63|9[25])|2(18|39|56|7[0147]|93)|3([03]5|14|5[89]|6[35]|79|8[569]|9[169])|4([167]1|25|[34]6|5[045]|93)|5(0[58]|17|[28]3)|6(09|[15]0|2[79]|35|4[25]|7[345]|8[14]|98)|7(0[0235-9]|1[013-689]|2[0-5789]|3[0-35-9]|[48]|5[013-7]|6[123569]|7[02346-9]|9[0-8])|8(0[02-6]|18|2[68]|4[07]|55|67|7[57]|8[09]|90)|9(15|28|77))|2(0(0[01]|13|4[58]|65|77|9[036])|1(0[013]|1[37]|25|34|4[468]|5[02]|6[38]|98)|2(18|27|3[48]|43|82)|3(0[04]|42)|4(50|63|7[39]|85)|5([06]5|2[34]|3[16]|4[48]|[79]0|81)|6(02|3[58]|5[17]|7[48])|7(18|82)|856|9(0[58]|12|2[07]|3[03]|[47]1|5[34]|63))|3(0(04|56|73|8[59])|1(0[34]|[26]4|37|51|95)|2(42|98)|3(02|1[03]|59|63|78|9[17])|4(27|48|52)|5([12]9|5[25]|9[29])|6(30|48|56|65|97)|7(43|56)|8(05|7[47]|83)|9(51|68))|4(0(0[1-7]|1[06])|1(0[18]|[15]1|4[47]|64|80)|2(07|1[146]|2[248]|46|[59]8|6[29]|85)|3(09|2[09]|46)|4(03|14|56)|5([057]3|22|34|9[23])|6(1[23]|2[38]|3[37]|4[69]|60|82)|7(15|57|69)|8(0[27]|3[37]|48|96)|9(06|11|22|60))|5(0(14|50)|1(44|7[68]|8[36])|2(0[048]|1[03]|43|5[36]|6[68]|79|81|9[2478])|3(1[68]|20|51|76|8[28]|9[36])|4(0[09]|1[0259]|2[18]|3[05]|4[2-57]|5[03]|6[67]|7[178]|8[37]|9[0236])|5(0[01249]|1[149]|2[35]|3[48]|40|[59][06]|65|77|8[345])|6(09|2[46]|51|8[03-8]|9[57])|7(05|20|48|5[37])|8([08]0|1[67]|22|3[0137]|47|63)|9(0[1346-9]|1[0234679]|23|3[013567]|4[02789]|5[039]|[68]8))|6(0(03|10|32|49|6[24])|1(0[047]|[14]3|84)|2(35|42|59|[67]0)|3([16]4|53)|4(02|75)|5(09|[19]8|5[25]|81)|6(14|6[68]|73|8[678]|9[02346])|7(01|14|20|3[59]|53|6[09]|[78]8|92)|8(0[056]|24|52|65|71|96)|9(06|12|2[37]|33|41|5[78]))|7(093|1(11|20)|2([18]8|39|56)|3(09|3[124579]|40|87)|4(0[38]|16|25|5[26]|6|7[012]|83)|5(02|14|45|88)|6(12|[45]4|76)|7([25]2|36|69|70|9[89])|8(42|96)|9(0[178]|54|81))|8(06[067]|1(06|58|6[567])|2(16|27|6[07]|7[04]|9[25])|3(25|30|5[13])|4(07|14|29|46|55|7[39]|80)|5(02|[48]0|7[06]|97)|6(02|[12]0|39|44|5[267]|65|7[35]|9[18])|7(0[01]|2[08]|3[1-49]|43|71|8[57]|92)|8(03|1[2456]|2[169]|3[026]|4[36-9]|5[01589]|7[19]|8[38]|9[0157])|9(0[02]|1[036]|3[14]|51|6[01789]|75|8[234]|9[128]))|9(0(0[45]|1[489]|2[18]|36|4[48]|68|77|8[2346]|99)|1(0[17]|1[179]|2[18]|3[16]|53|6[01459]|70|98)|2(0[068]|1[013567]|2[1279]|3[01]|4[1-6]|56|6[157]|7[0149]|8[368]|9[2578])|3(0[489]|1[18]|2[15]|[39]9|4[346]|5[01]|6[057]|7[39]|8[278])|4(07|1[2678]|2[589]|3[047]|4[67]|5[2-9]|6[0-35]|7[167]|88|9[12])|5(0[056]|1[34578]|2[4-7]|3[016]|4[28]|5[0238]|87|9[04])|6(0[25]|1[123]|2[09]|3[2368]|4[27]|5[1348]|6[15]|7[147]|8[14678]|9[13])|7(0[01369]|1[0139]|2[15-9]|38|4[489]|5[1367]|6[124]|7[69]|8[135-9]|9[0-37])|8(0[0246-9]|1[1-689]|2[0124-79]|3[0-4789]|4[2-9]|5[13457]|6[1-4679]|7[0235-8]|8[45689]|9[1-46-9])|9(0[025-9]|[14]|2[0135-9]|3[0-46-9]|5[02-9]|6[0-4679]|7[0-689]|8[6-9]|9[01389])))|9([02-579]|1([013-9]|2([0-5789]|6[1-9]))|6([0-689]|7([0-689]|7[02-9]))|8([0-689]|7([0-35-9]|4[0-46-9]))))|6(0(0(05[34]|1(02|23|76)|2(0[368]|9[5-9])|3([02457]|1[0-46-9]|3[0-5789]|6[0124-9]|8[0124568])|4(01|[35]2|6[34]|7[29])|5(0[459]|5[59]|98)|6([26]5|[47]8)|7(22|93)|8(1[58]|29|3[13]|52|6[24])|9(0[189]|1[27]|20|33|7[38]|8[19]|9[0-38]))|1(0([07][03]|2[14]|3[09]|47|5[06]|65|8[239]|99)|2(0[12369]|1[0124-9]|2[0-689]|3[02-9]|[46]|5[0-46-9]|7[0-69]|8[1-46-9]|9[1-9])|3(0[19]|14|4[45]|5[46]|6[789]|7[27])|4(0[014]|18|22|35|41|5[12]|93)|5(0[08]|1[89]|3[12]|4[14]|79|8[27]|94)|6([0249]|[17][0-46-9]|3[0-5789]|[58][0-79]|6[0-35-9])|7(0[05]|4[23]|5[09]|82)|8(19|4[02]|8[0147])|9(00|12|76|9[39]))|2(0(0[068]|1[124689]|2[0-8]|3[1-9]|50|67|73)|1(40|88)|319|447|6(48|51|7[68]|95)|792|8(17|71|82)|9(08|[17]0|54|81))|3(0([16]1|54|7[18]|8[03]|9[28])|1(1[12]|2[023578]|[36]4|[49]8|82)|2([09]8|1[346]|32|[45]6|69|83)|3(01|1[126]|2[56]|3[59]|4[023469]|53|78|8[23]|9[5679])|4(0[09]|[258]0|[47]5|9[24])|5([05]5|2[789]|74|88|9[01])|6(0[023589]|1[34]|28|34|4[49]|7[0-4]|8[134]|9[23])|7([19]7|22|33|41|6[39]|7[08]|88)|8(4[15]|68)|9(13|48|5[19]|60|7[1-9]|8[0124-79]))|4(0(19|33)|[15]|4(0[1-9]|[13-9]|2[01346-9])|6(1[23]|36|4[46]|78)|77[69]|8(0[69]|[19]7|[45][12]|63)|9(06|[14]8|3[389]|[56]1|7[26]|8[234]))|5(0(0[067]|27|[36]6|75)|230|360|4(21|6[12])|5(29|36|44)|6(23|68)|775|8(39|91))|6(0([0-369]|4[0-46-9]|5[013-9]|7[02-9]|8[0-8])|1(14|2[456]|4[45]|6[36]|7[29])|2(0[09]|2[48]|3[368]|5[27]|6[039]|8[045]|99)|3(05|2[19]|3[79]|49|7[24]|8[569]|9[45])|4(01|36|4[45]|52)|667|711|801|931)|7888|9(002|5(68|95)|966))|1(04(11|22)|5009|6788|7435|843)|2(0272|1(409|8[368]0|9(8[46]|9[29]))|2(0(18|[79]2)|1(06|10|22))|3977|7(089|1(01|19|[27]3|6[16]|80)|2(40|5[24]|78)|3(18|47|5[258]|6[46]|99)|4(41|5[346]|6[27]|79)|5([148]2|3[49]|68|74|9[28])|6(09|[39]6|43|6[59]|74)|7(0[1-9]|[179]|2[0-46-9]|3[0-5789]|4[1-5789]|5[02-9]|6[0124-9]|8[1-4789])|8(0[12]|16|69|92)|9(20|5[09]|7[39]|9[25]))|8(0(28|39|47|8[12]|95)|1(10|3[23]|55))|94(4[1-9]|5[0-3]))|3(0(0(00|28)|1(14|21)|[27]22|4(0[0189]|12|4[015]|56|61|7[789]|8|9[0-8])|521|953)|1(0(00|9[02])|240|307|6(81|98)|9(4|82))|2467|3(000|1(10|33|5[18]|6[34]|74)|2(04|19|35|[46]0|9[56])|3[0-4]|4[5-9]|5(13|34|[479]7|5[15]|86)|6([27]5|41|9[58])|7(48|67|7[46]|80|91)|8([125]7|45|7[1268]))|4(0(0[145689]|51)|1(04|79)|207|852)|5(037|482|6(0[18]|18|29|3[49]|50)|903)|6(0([78]8|9[167])|1(01|1[1267]|4[16]|6[24]|73)|2(68|87)|3([17]5|2[59]|39|47|9[26])|4(06|4[78])|5([18]7|23|48)|6([02]8|39|8[49]|93)|7(0[48]|36|78)|8(42|6[08])|9(3[79]|57|64))|7(0(43|74)|1([09]2|18|87)|2(17|43)|3(33|6[49])|5(29|56)|780)|8(101|216|564|685)|9(0(0[2459]|1[028]|25|4[5-9]|5|6[0-8]|72|8[6-9]|9[02789])|1([012]|3[039]|51|6[19]|7[04]|99)|2(07|1[23]|2[169]|3[13]|4[08]|61)|3(00|5[08]|[67]2|9[0-3])|4(0[16]|44|5[07]|66|8[59])|5([08]9|3[13]|55|61|97)|6(07|1[48]|[27]3|4[459]|50|64)|7(6[34]|77|81|90)))|4(0(00[15]|2([24]1|52)|3(45|57)|4(11|75|83)|6(14|71))|1(377|466)|2(0(1[12]|9[78])|1(08|1[09]|73)|2(2[23]|40|58)|3(01|[458]4|62|7[36]|9[159])|4(26|3[03]|45|91)|5(01|14))|3(2(0|12|[67]0|8[01])|632))|6(0(0(0[06]|11|99)|1(00|91)|2(15|94)|383|408|65[01]|7(1[13]|91)|801)|1(010|1([02]0|3[89])|2(32|49|57)|431|6(60|99)|800|938)|2(000|2(02|4[12])|40[57]|637|741|829|972)|3(1(05|5[36])|2(05|54|70)|329|6(39|80)|7(15|26)|834|921)|4(09[06]|260|386|4(63|7[15])|581|662|765)|5(0(12|97)|4(22|67)|5(31|55)|6(48|76)|722|9(42|79|80))|6(0|282|4(00|14|42|96)|554|6([56]5|8[08]|99)|739|887|963)|7(0[05]1|100|2(07|30|95)|305|460|5(12|31)|6(36|45)|7([08]0|39)|8(45|96)|9(25|50|97))|8(020|3(27|45|99)|465|503|668|7(00|61)|830|9(00|5[14]|78))|9(0(0[01]|3[58])|235|494|5[78]2|672|8(69|87)|958))|7(0([0127]|4(0[0125]|1[03]|34|96)|5([0146]|[25][013-9]|3[02-9]|7[0-8]|8[1-8]|9[0-46-9])|6([0146]|2[02-9]|3[0-5789]|5[1-9]|7[0-8]|8[14-9]|9[0145689])|8(0[01246-9]|[15]|2[013-9]|3[0124-9]|4[02-79]|6[2-9]|[79][0-7]|8[89])|9(0[015]|11|44|6[12357]|7[02]|8[1-9]|9[02-9]))|1(0|1(0[0-35-9]|[15][013-9]|2[0-46-9]|3[013-8]|4[4-9]|6[0-35679]|7|8[01678]|9[0124579])|2(0[012689]|1[01245789]|20|3[234]|59|[67]8|94)|3(0[0-35-9]|[13-9]|2[0-79])|4(02|96)|5(01|[46]0|83|99)|6(77|8[01])|718|8([0-79]|8[0-35789])|9([68]0|77))|2[0-69]|3(0(0[0234]|4[127]|52|70|99)|1(0[0-36]|11|23|4[05]|[57]|60|8[01]|92)|2(0[1-689]|1[0-579]|[29]|3[015-9]|4[0-46-9]|5[05-9]|6[0-35]|7[1567]|8[01])|3([0-4]|50|68|7[67]|87)|4(0[0-6]|22|4[48]|50|8[09]|98)|5|6(36|6[07]|7[05]|8[09]|90)|7([014]|20|3[03]|55|7[013]|83)|8(2[26]|63|99)|9(0[0-4]|2[02]|60|[79]9))|4([01257]|3([02-578]|1[0-46-9]|6[02-9]|9[0-79])|4(0[04-9]|[1-8]|9[0-689])|6(0[0-35-9]|1[013-9]|[24-9]|3[02-79])|8(28|3[2-9]|[4-9])|9(10|47|73))|5(0(0[01]|13|27|49|5[08]|70)|1(0[04]|13|30|41)|2(05|20|92)|3(01|32|[89]7)|4([15]4|21|3[28]|67|76|89)|5(49|68|76|92)|6(16|21|[38]3|92)|7([12]4|5[234678]|6[012]|76|95)|8(20|31|49|56)|9([0-689]|7[04-9]))|6(0(0[012]|3[68]|47|5[2-9]|6|7[0-8]|8[27])|1(0[0236-9]|1[0124-9]|2[1-79]|3[01]|4[0568]|6[03-9]|7[0-4789]|[89])|2(0[013-9]|1[04-79]|2[1346-9]|3[013467]|4[015-9]|5[0-689]|6[1-5789]|7[0-468]|8[023679]|9[1-9])|3([013]|2[13-79]|4[0-46-9]|5[15-9]|6[0-689]|7[1-46-9]|8[013457]|9[02-9])|4(0[0-35-8]|1[124-9]|2[0-5789]|3[2-8]|[4679]|5[0124569]|8[0124-9])|5(0[1-9]|[12358]|4[0135689]|6[013-9]|7[01245689]|9[0135789])|6(0[146-9]|1[1-589]|[2367]|4[02-9]|[58][0-5789]|9[0678])|7|8(0[02-589]|1[0-4689]|[26][0124-9]|3[0-6]|[49]|5[0-35689]|7[024-9]|8[01245689])|9(0[02-9]|[189]|2[1236-9]|3[02346-9]|4[1235-9]|5[0-79]|6[0124-9]|7[1-5789]))|7(0(0[1235689]|[13][0-8]|2[0-79]|[47][013-9]|[58]|6[01346-9]|9[0-389])|1([079]|1[0124-7]|2[02-578]|3[0-8]|4[0-46]|5[1245]|6[235-9]|8[013-9])|2(0[013-9]|[15][0-46-9]|[23][1-9]|[4689]|7[0-689])|3([0149]|2[02-5789]|3[14-9]|5[1-9]|6[0-46-9]|7[0-689]|8[0-35-9])|4([069]|1[02-9]|2[0124-9]|3[0-5789]|4[124-9]|5[013-9]|7[0-36-9]|8[0124789])|5([0349]|1[0124-9]|2[0124-8]|5[0-8]|6[3-9]|7[014-9]|8[0-69])|6([04][0-35-9]|[18]|[29][0-79]|3[0-7]|5[03569]|6[0125-9]|7[01246-9])|7(0[0-8]|1[0-46-9]|2[1-8]|31|72|8[08])|8(09|20|56|78)|9([1367]0|2[01]|5[09]|95))|8(0(09|80)|196|2([01]3|34|41|76|95)|3(0[45]|70|9[69])|4(00|2[45]|63)|5(1[49]|3[27]|4[69]|56|78|84)|6(1[69]|5[47]|80)|7(02|65|79|8[08]|90)|8([08]8|14|3[45]|[47]6|65|9[378])|9(0[013]|12|31|4[25]|75|8[89]))|9(0([0124-9]|3[0124-9])|1([0-3]|4[123567]|5[26]|6[23467]|7[018]|8[12568]|9[1-69])|2(12|23|39|50|9[123])|3(1[03]|81)|406|5(00|22|5[07])|63[78]|7(10|58|6[02])|8(3[568]|4[0128]|53)|9(0[01]|2[2367]|32|4[13]|5[17]|61|8[04-9]|9[0-5789])))|8(0(0(00|72)|156|214|5([07]1|26|68)|618|8[01]0|910)|1(095|100|234|363|450|549|681|790|87[08]|940)|2(01[45]|181|362|490|5[012]0|656)|3(050|454|5(61|78)|703|845|9(00|45))|4(0(55|80)|168|[26]17|357|4[13]1|7(23|35|[69]8)|853|9(2[19]|64))|5(068|1[04]0|3(41|73)|470|540|759)|6(0[07]0|1(17|[79]6)|2(04|19|61)|483|7(44|67|82)|8(0[89]|30|68))|7(0(05|32|64)|2(44|83)|322|4(23|42|74)|636|749|9(54|65|79))|8(028|1(22|40|77)|5(23|40)|6(09|75)|7(23|46)|82[04])|9(0(0[01]|99)|[13]70|2(08|35|42|53|97)|937))|9(0(0(0[0279]|17|25|32|54|99)|1(01|49|72)|231|413|970)|1(1(0[06]|41)|3(13|39)|[48]01|5(10|97)|710)|2(042|18[12]|253|5(05|50)|[68]93|711)|3(0(0[23]|1[04]|57|99)|134|312|40[59]|5(23|74)|689|7(00|1[15])|800)|4(2(09|30|58)|675|8(30|58)|982)|5(0(00|1[07]|54)|1([16]1|32)|4(30|77|85)|588|896|9(21|4[36]))|6(0(00|11)|196|28[02]|352|450|[56]69|857|9(00|69))|7(0(00|9[06])|196|3[06]1|530|6(45|87)|720|8(07|29)|901)|8(011|113|233|4(06|53)|5(34|55)|6(44|53)|7(03|45|6[36])|857)|9(0(0[12]|87)|110|3[34]1|4(04|23)|696|9(06|3[07]|99))))|7(0(6980|8252)|24365|58005|744[1-9])|990015)/,
    length: [12, 13, 14, 15, 16, 17, 18, 19],
    cvcLength: [3],
    logo: require('@/assets/images/cards/Maestro.png'),
    cardType: 'MAESTRO', // 后端未匹配
  },
  {
    type: 'Mastercard',
    pattern: /^(2(2(2([1-7]|8([0-79]|8[0-7])|9([06][0-8]|1[1-4678]|[2-5789]))|[3-8]|9([013-9]|2([0124-9]|3[0-6])))|3(0([0-7]|8([0-79]|8[02-9])|9([034578]|[12][0-689]|6[0124-9]|9[0125-9]))|[1-9])|4([0-5789]|6([0-689]|7(0[0-5789]|[1-9])))|5(0(0(0[1-9]|[1-9])|[1-9])|[1-9])|6|7(0([02-9]|1([0-5789]|6[0-79]))|1|20))|5(1([0124-9]|3([0125-9]|3([02-9]|1[013-9])|4([013-9]|2[0124-9])))|2(0(0([0-46-9]|5[0124-9])|[124-9]|3([0124-9]|3[0-5789]))|1([0-8]|9([0-46-9]|5[0-8]))|[26]|3(0([0-8]|9[0-5789])|[1-9])|4([0-46-9]|5([0-46-9]|5[02-9]))|5([0-79]|8([02-9]|1[1-9]))|7([01245789]|3([02-9]|1[013-9])|6(0[02-9]|[1-9]))|8([0-79]|8([013-9]|2[0-79]))|9([0134589]|2([0124-9]|3[0-46-9])|6([013-9]|2[0-79])|7([0-8]|9[0-46-9])))|3([0-35]|4(0([0-8]|9[02346-9])|[1-9])|6([02-9]|1(0[0-5789]|[1-9]))|7([0-79]|8([02-9]|1[0-46-9]))|8([0-35-9]|4([0-46-9]|5[0-689]))|9(0([0-8]|9[0-35-9])|1([0-35689]|4[0-46-9]|7[0-5789])|[2-9]))|4([0-5789]|6([0-46-9]|5([0-46-9]|5[0124-9])))|5(0(0([02-9]|1[0-5789])|[1-9])|[1256]|3(0([0-79]|8[0-46-9])|[1-9])|4([0-36-9]|4([0-689]|7[013-9])|5(0[0-35-8]|[1-57]|6[0124-9]|8[0-689]|9[013-9]))|7([01478]|2([0-578]|6[0124-9]|9[0-35-9])|3([0124-9]|3[0-5789])|5([0-6]|7[12467]|8[1-9]|9[049])|6(0[0-46-9]|[14][1-9]|[23678]|5[2346-9]|9[0-79])|9([0124-8]|3[0-69]|9[013-8]))|8([0-46-9]|5([0-5789]|6[013-9]))|9([0-579]|6(0[1-9]|[1-4789]|5[0-8]|6[0-5789])|8([0569]|1[013-9]|2[0-3578]|3[24689]|4[0-8]|7[0-689]|8[0-35-9])))))/,
    length: [16],
    cvcLength: [3],
    logo: require('@/assets/images/cards/Master.png'),
    cardType: 'MASTERCARD',
  },
  {
    type: 'Dankort',
    pattern: /^5019/,
    length: [16],
    cvcLength: [3],
    logo: require('@/assets/images/cards/Dankort.png'),
    cardType: 'DANKORT', // 后端未匹配
  },
  {
    type: 'DiscoverCard',
    pattern: /^(389991|6(011([02349]|11|7[4789]|8[6-9])|4[4-9]|5(0(0([0129]|3[04]|5[2-6]|8[2-9])|[1238]|4(0[0-4]|[4-7]|8[0134])|5([39]9|4|5[01])|6(0[1-9]|[1-9])|7([013-9]|2[89])|9(00|2[3-79]|3[0-7]|4[0-5]|79|[89]))|1([0-589]|6([0-4]|5[01])|7(0[5-9]|[1-9]))|2([067]|1([0-4]|67|72)|2(2[24]|6[379]|7[012457]|8[0479]|9[013678])|3(07|1[89]|2[1245789]|[3-9])|4(0[1-9]|[1-9])|5(09|1[5-9]|2[2-9]|[346-9]|5[1-9])|8([0-4]|57|6[89]|7[1569]|8[012]|9[269])|9(0[13-9]|[1-9]))|3(0(0[0125-9]|[1-9])|[1-9])|[46-9]|5(0(20|59|[6-9])|[1-9]))))/,
    length: [16, 17, 18, 19],
    cvcLength: [3],
    logo: require('@/assets/images/cards/DiscoverCard.png'),
    cardType: 'DISCOVER',
  },
  {
    type: 'ChinaUnionPay',
    pattern: /^(6(0(1(382|428)|29(07|69)|3(265|367|6(01|94)|708)|4823|60(45|52))|2(0(0(09|1[0139]|2[14-7]|3[01579]|4[68]|5[04689]|6[348]|7[029]|8[568]|9[14])|1(0[135-8]|1[48]|2[03-69]|3[126]|4[23689]|5[23]|6[02-689]|8[3-7])|2(0[2-9]|1[018]|20|49|78)|342|4(11|27)|5(1[35-8]|2[2789]|3[0-3578]|5[0129]|6[12])|8(12|26)|938)|1(0(0[13-68]|1[0-5789]|2[013-9]|[356][0-35-9]|4[0-59]|7|8[0-4689]|9[0124-9])|1(00|32)|2(0[01]|1[235-9]|[28][0-8]|3[0-5789]|[479]|5[0124-9]|6[03-9])|3(0[018]|1[046]|2[4-8]|[34689]|5[0-69]|7[1235-9])|4(0[13]|1[1-9]|2[0238]|3[346-9]|4[0-35-9]|5[235-8]|6|7[056]|8[0-8]|9[0124-9])|5(00|1[5-9]|2|3[0-46-9]|5[012789]|6[0-3689]|7[789]|8[02589]|9[01289])|6(0[01]|1[79]|2[13-8]|3[0135-9]|4[0125789]|5|[67][0-689]|8[0-5789]|9[0-79])|7(00|19|2[0-35-8]|3[0-35-9]|4[0-36-9]|[5-9])|840|9(7[79]|80))|2(0(03|21)|1(00|2[6-9]|[3-9])|[2-9])|3(0(0[01347]|1[036-9]|[23789]|4[0-578]|5[0-35-9]|6[0-8])|1(0[1-9]|[1235-8]|4[0235679]|9[03-9])|2(0[0135-9]|1[0-3689]|2[019]|5[0589]|6[12357]|9[36])|3(0[02-5789]|1[0-8]|2[1-9]|3[124-9]|4[014-9]|5[0-35789]|6[024-9]|7[0-69]|[89])|4(0[24-9]|[145]|2[0-5789]|3[02-589]|6[0124-7]|7[015-9]|8[0-578]|9[1235-9])|5(0[1-689]|[1578]|2[1-9]|3[0-5789]|4[0-3789]|6[0-35-9]|9[02-9])|6(0[013-9]|1[0135-9]|2[1-8]|[36][0-5789]|4[0-4678]|5|7[02-9]|8[034678]|9[489])|748)|[45]|6([013-9]|2([0-3]|4[0-6]|5[012489]|6[0124-9]|7[013-9]|8[014-9]|9[0345789]))|7(0(0[26]|2[05-8]|4[0-3]|6[013-9]|7[03-68])|1(0[04]|1[01]|92)|2(0[09]|3[02]|[46]4)|3(2[89]|48|53|69)|4([07]1|80)|5(17|33)|6([27]9|45|52|6[68]|81)|8([01]5|51|62|79|94)|9([02]3|69))|8(0(0[09]|3[48]|51|7[256]|83|9[23])|1(06|15|79|80)|[2-8])|9(095|1(0[012]|1[0-3567]|2[89]|3[0-35689]|4[0-4789]|5[0-8]|[67][1-9]|80)|2(1[0124-7]|2|3[036-9]|4[0124789]|5[12456]|6[0129]|7[1-4789]|8[13-9]|9[015])|43[36]|8([48]6|64)|9(49|7[45])))|3(0042|2062|6(09[345]|189)|9(339|578))|85800|9075)|81(0|1([0-3]|4([01]|2[012]))|4(6(3[1-9]|[4-9])|7|8([0-6]|7[0-4]))|7[01])|9(00[12]05|111|400(0[13]|1[0358]|2[01378]|3[01579]|4[06-9]|5[056]|6[12368]|7[34])|55(100|5[59]0|88[08])|6(6666|8807)|8430[0-3]|9(0027|880[012])))/,
    length: [16, 17, 18, 19],
    cvcLength: [3],
    logo: require('@/assets/images/cards/ChinaUnionPay.png'),
    cardType: 'UNIONPAY',
  },
  {
    type: 'RuPay',
    pattern: /^(353(600|8(0[0-35-9]|10))|50(2801|8(5(0[0124-9]|1[25689]|[26][0-8]|3[02346-9]|4|5[1-9]|7[03479]|8[1235789]|9[0-4678])|6(0[0-3789]|1[0-4679]|2[025789]|3[2-79]|4[02-9]|[57]|6[0134579]|8[0-79]|9[013-9])|7(0[01346-9]|1[0-35-9]|[2-7]|8[0-689]|9[0-578])|8(0|1[02-9]|2[0-5789]|[37][0-68]|4[0-35-9]|5[0-7]|6[013-9]|8[0345789]|9[01345789])|9([06][1-9]|[1-49]|5[0-35-9]|7[13-79]|8[01345789])))|6(0(6(1(0[02-5789]|1[0-35-9]|2[013789]|3[0-8]|4[0-36-9]|[589]|6[01245789]|7[013-8])|2(0[1-8]|[14]|2[0-35679]|3[0124579]|5[013-689]|6[124-8]|7[0-35-9]|8[13689]|9[0-4678])|3(0[0-46-9]|1|2[0234678]|3[01248]|4[0-7]|5[0-689]|6[0236-9]|7[0135-8]|8[0-378]|9[0-36-9])|4(0[0235-9]|1[1-9]|[279]|3[0-5789]|4[0236-9]|5[13-689]|6[0-8]|8[0-35-9])|5|6([0-5789]|6[0-689])|7([02-9]|1[02-9])|8(0[02-9]|[13-9]|2[0-689])|9(0[0124-9]|1[0-5789]|[25-9]|3[0235789]|4[1-9]))|7([0-35679]|4([0-689]|7[0-46-9])|8([0-79]|8[0-79]))|8([0124589]|3([0-35-9]|4[0124-9])|6([0-8]|9[0-79])|7([02-9]|1[1-9])))|27387|5(2(1([589]|6[0-689]|7[013-9])|2([01345]|2[0135-9]|6[0124568]|7[3689]|8[123568]|9[2459])|3(0[0-689]|1[0-7]|2[036])|400|5(0[0-8]|1[0-4]|2[01]|50)|8(5[0-689]|6[0-7]|7[023478]|8[3-9]|9[0134578])|90[02])|300[34])|95047)|8(17(2(0[03479]|1[124578]|2[045789]|3[0-578]|4[125679]|5[0289]|6[0128]|7[5689]|84|9[05])|3(0[57]|14|3[67]|4[23]|56|7[01]))|20199|88888)|999999)/,
    length: [16],
    cvcLength: [3],
    logo: require('@/assets/images/cards/RuPay.png'),
    cardType: 'RUPAY', // 后端未匹配
  },
  {
    type: 'Visa',
    pattern: /^(4(0([02-9]|1([02-9]|1([0-689]|7[0-7])))|[14689]|2(0([012679]|3([02346-9]|1[0124-9]|5[0-35-9])|4(0[0-489]|1[13-79]|2[0-35679]|3[012469]|4[01346-9]|5[0-35-9]|6[0378]|7[0236-9]|8[14-79]|9)|5(0[0-58]|[1235789]|4[0-35-9]|6[02-9])|8(0[0-46-9]|1[13489]|2[25]|3[015-9]|4[0-689]|5[0-35-9]|6[0-7]|7[0124-9]|8[03-79]|9))|[1-9])|3([02-79]|1([013-9]|2([0-689]|7[0-35-9]))|8([0-8]|9([0124-9]|3[0-46-9])))|5([02-689]|1([0-35-9]|4([02-9]|1[0-5789]))|7([01245789]|3([0-8]|9[0124-9])|6([0124-9]|3[03-9])))|7([02-9]|1(0(0[15]|1[13569]|2[35-9]|3[2679]|42|5[058]|6[18]|7[39]|83|9[056])|[1-9])))|5(64158|79398|89(450|83[56]))|621996)/,
    length: [13, 14, 15, 16],
    cvcLength: [3],
    logo: require('@/assets/images/cards/visa.png'),
    cardType: 'VISA',
  },
  {
    type: 'Argencard',
    pattern: /^(501105)/,
    length: [16],
    cvcLength: [3],
    cardType: 'ARGENCARD', // 后端未匹配
  },
  {
    type: 'Cabal',
    pattern: /^((627170)|(589657)|(603522)|(604((20[1-9])|(2[1-9][0-9])|(3[0-9]{2})|(400))))/,
    length: [16],
    cvcLength: [3],
    cardType: 'CABAL', // 后端未匹配
  },
  {
    type: 'Naranja',
    pattern: /^(589562)/,
    length: [16],
    cvcLength: [3],
    cardType: 'NARANJA', // 后端未匹配
  },
  {
    type: 'Cencosud',
    pattern: /^(603493)/,
    length: [16],
    cvcLength: [3],
    cardType: 'CENCOSUD', // 后端未匹配
  },
  {
    type: 'Nativa',
    pattern: /^((520053)|(546553)|(554472)|(531847)|(527601))/,
    length: [16],
    cvcLength: [3],
    cardType: 'NATIVA', // 后端未匹配
  },
];
// Luhn算法验证卡号
export const luhn = (cardNumber) => {
  let total = 0;
  const cardNumberLength = cardNumber.length;
  if (cardNumberLength < 13 || cardNumberLength > 19) {
    return false;
  }
  const maxLength = cardNumberLength + 1;
  for (let i = 1; i < maxLength; i++) {
    let num = parseInt(cardNumber.substring(cardNumberLength - i, cardNumberLength - i + 1));
    if (i % 2 === 0) {
      num *= 2;
      if (num < 10) {
        total += num;
      } else {
        var t1 = num + '';
        total += parseInt(t1.substring(0, 1)) + parseInt(t1.substring(1, 2));
      }
    } else {
      total += num;
    }
  }
  return total % 10 === 0;
};

// 验证CPF
const validarCPF = (cpf) => {
  const cpfDigits = cpf.replace(/[^\d]/g, ''); // 移除所有非数字字符
  if (cpfDigits.length !== 11) {
    return false;
  }
  // 检查重复数字
  if (/(\d)\1{10}/.test(cpfDigits)) {
    return false;
  }
  // 验证算法
  for (let t = 9; t < 11; t++) {
    let d = 0;
    for (var c = 0; c < t; c++) {
      d += parseInt(cpfDigits.charAt(c)) * ((t + 1) - c);
    }
    d = ((10 * d) % 11) % 10;
    if (parseInt(cpfDigits.charAt(c)) !== d) {
      return false;
    }
  }
  return true;
};

// 验证CNPJ
const validarCNPJ = (cnpj) => {
  const cnpjDigits = cnpj.replace(/[^\d]/g, ''); // 移除所有非数字字符
  if (cnpjDigits.length !== 14) {
    return false;
  }
  let size = cnpjDigits.length - 2;
  let numbers = cnpjDigits.substring(0, size);
  const digits = cnpjDigits.substring(size);
  let sum = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    // eslint-disable-next-line no-plusplus
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(result) !== parseInt(digits.charAt(0))) {
    return false;
  }
  size = size + 1;
  numbers = cnpjDigits.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    // eslint-disable-next-line no-plusplus
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(result) !== parseInt(digits.charAt(1))) {
    return false;
  }
  return true;
};

export const allRules = {
  // 必填校验默认为false 只有点pay后才激活为true
  required: function(field, translate = true, toLowerCase = true, trigger = ['blur', 'change']) {
    let fieldName = translate ? i18n.t(field) : field;
    fieldName = toLowerCase ? fieldName.toLowerCase() : fieldName;
    return {
      name: 'required',
      required: false,
      // message: i18n.t('message.validator.input', { field: fieldName }),
      // 默认不显示错误信息, 现在必填message特殊处理 放在右上角
      message: ' ',
      trigger,
    };
  },
  cardNumber: function(rule, value, callback) { // 卡号
    // 现在没值的时候不做格式校验
    if (!value) {
      callback();
    }
    const num = value.replace(/\s*/g, '');
    const validate = luhn(num);
    if (!validate && value) {
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.cardNumber').toLowerCase() })));
    }
    callback();
  },
  monthYear: function(rule, value, callback) { // 卡有效期
    // 现在没值的时候不做格式校验
    if (!value) {
      callback();
    }
    const val = value;
    const n = new Date();
    var y = n.getFullYear();
    var m = n.getMonth() + 1;
    if (val.indexOf('/') > 1) {
      const myArray = val.split('/');
      const month = Number.parseInt(myArray[0]);
      const year = Number.parseInt(myArray[1]);
      // 1. 月份必须是两位数 2. 年份必须是两位数或者四位数 3. 月份必须小于等于12 4. 输入格式是MM/YY或者MM/YYYY
      if (myArray.length !== 2 || (myArray[1].length !== 2 && myArray[1].length !== 4) || (myArray[0].length !== 2) || (month > 12)) {
        callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() })));
        return;
      }
      if (myArray[1].length === 4) {
        if (y < year || (y === year && m <= month)) {
          callback();
        } else {
          callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() })));
        }
        return;
      }
      if ((y % 100 < year) && ((year - (y % 100)) < 25)) { // 年份比现在大
        callback();
      } else if (y % 100 === year && m <= month) { // 月份比现在大
        callback();
      } else if (((year - (y % 100)) === 25) && m >= month) {
        callback();
      } else {
        callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() })));
      }
    } else if (val.length <= 0) { // 未填内容
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() })));
    } else { // 内容未填写正确
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() })));
    }
  },
  cvv: function(rule, value, callback) {
    // 现在没值的时候不做格式校验
    if (!value) {
      callback();
    }
    let val = value || '';
    val = val.trim();
    const len = val.length;
    if (len >= 3) { // 正确
      callback();
    } else if (len === 0) { // 未填写
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.cvv').toLowerCase() })));
    } else { // 长度不对
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.cvv').toLowerCase() })));
    }
  },
  holderName: (rule, value, callback) => { // 持卡人姓名
    // 现在没值的时候不做格式校验
    if (!value) {
      callback();
    }
    const val = value && value.trim();
    const valArr = val.split(' ');
    if (valArr.length < 2) { // 持卡人姓名必须以空格分割
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.holderName').toLowerCase() })));
      return;
    }
    callback();
  },
  email: function(rule, value, callback) { // Email
    // 现在没值的时候不做格式校验
    if (!value) {
      callback();
    }

    const val = value && value.trim();
    /**
     * 必须要有“@”；
     * 只能存在一个“@”，不能存在多个“@”；
     * “字符或者数字”是第一个字符；
     * “@”或“.”不能是最后一个字符；
     * “@”之后至少要有一个“.”；
     * “@”之后除“.”和"-"外，不能出现特殊字符；
     */
    const regex = /^[a-zA-Z0-9]+[^@]*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    if (regex.test(val)) {
      callback();
    } else {
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.email').toLowerCase() })));
    }
  },
  birthDate: function(rule, value, callback) {
    if (!value) { // 必填单独验证
      callback();
    }
    const val = value && value.trim();
    // YYYY/MM/DD
    const dateArr = val.split('/');
    if (dateArr.length !== 3) {
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.birthDate').toLowerCase() })));
    } else {
      const regex = /^\d*$/;
      if (regex.test(dateArr[0]) && regex.test(dateArr[1]) && regex.test(dateArr[2])) {
        if (dateArr[0].length === 4 && dateArr[1].length === 2 && dateArr[2].length === 2 && dateArr[1] <= 12 && dateArr[2] <= 31) {
          if (isNaN(new Date(value).getFullYear())) { // 检查是否是合法的日期
            callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.birthDate').toLowerCase() })));
          } else {
            callback();
          }
        } else {
          callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.birthDate').toLowerCase() })));
        }
      } else {
        callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.birthDate').toLowerCase() })));
      }
    }
  },
  issueDate: function(rule, value, callback) {
    if (!value) { // 必填单独验证
      callback();
    }
    const val = value && value.trim();
    if (val.indexOf('/') > 1) {
      const myArray = val.split('/');
      const month = Number.parseInt(myArray[0]);
      // 1. 月份必须是两位数 2. 年份必须是两位数或者四位数 3. 月份必须小于等于12 4. 输入格式是MM/YY或者MM/YYYY
      if (myArray.length !== 2 || (myArray[1].length !== 2 && myArray[1].length !== 4) || (myArray[0].length !== 2) || (month > 12)) {
        callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.issueDate').toLowerCase() })));
        return;
      }
      callback();
    } else if (val.length <= 0) { // 未填内容
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.issueDate').toLowerCase() })));
    } else { // 内容未填写正确
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.issueDate').toLowerCase() })));
    }
  },
  identityNumberRequired: function(country, rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    const newValue = value.trim();
    const fieldName = identityNumberLabel[country] ? identityNumberLabel[country] : 'document';
    if (!newValue) {
      callback(new Error(i18n.t('message.validator.input', { field: fieldName })));
      return;
    }
    callback();
  },
  identityNumber: function(country, rule, value, callback) {
    if (!value) { // 必填单独验证
      callback();
    }
    const newValue = value.trim();
    if (country === 'BR') {
      const idNum = newValue.replace(/[^\d]/g, '');
      if (idNum.length < 11 || idNum.length > 14) {
        callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
        return;
      }
      // 校验CPF和CNPJ
      const cpf = validarCPF(idNum);
      const cnpj = validarCNPJ(idNum);
      if (!cpf && !cnpj) {
        callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
        return;
      }
      callback();
    } else if (country === 'CL') {
      if (newValue.length < 8 || newValue.length > 9) {
        callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
        return;
      }
      callback();
    } else if (country === 'CO') {
      if (newValue.length < 6 || newValue.length > 10) {
        callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
        return;
      }
      callback();
    } else if (country === 'PE') {
      if (newValue.length < 8 || newValue.length > 9) {
        callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
        return;
      }
      callback();
    } else if (country === 'UY') {
      if ((newValue.length >= 6 && newValue.length <= 8) || newValue.length === 12) {
        callback();
        return;
      }
      callback(new Error(i18n.t('message.validator.input', { field: identityNumberLabel[country] })));
    } else {
      callback();
    }
  },
  blikcode: function(rule, value, callback) {
    if (!value) { // 必填单独验证
      callback();
    }
    if (value.length !== 6 || !(/^[0-9]+$/.test(value))) {
      callback(new Error(i18n.t('message.validator.input', { field: i18n.t('message.checkout.blikcode').toLowerCase() })));
      return;
    }
    callback();
  },
};

export const cardFormRules = () => {
  return {
    // cardNum: [
    //   allRules.required('message.checkout.cardNumber'),
    //   { validator: allRules.cardNumber, trigger: 'blur' },
    // ],
    // expireDate: [
    //   allRules.required('message.checkout.expiredDate'),
    //   { validator: allRules.monthYear, trigger: 'blur' },
    // ],
    // cvv: [
    //   allRules.required('message.checkout.cvv'),
    //   { validator: allRules.cvv, trigger: 'blur' },
    // ],
    // holderName: [
    //   allRules.required('message.checkout.holderName'),
    //   { validator: allRules.holderName, trigger: 'blur' },
    // ],
    // intallment: [
    //   allRules.required('message.checkout.intallment'),
    // ],
    // periodValue: [
    //   allRules.required('message.checkout.intallment', true, true, 'change'),
    // ],
  };
};
